/**
 * Best-effort removal of a key from localStorage.
 *
 * Accessing `localStorage` throws a `SecurityError` in browsers that block all
 * cookies/storage (e.g. Firefox's "block all cookies" setting), so callers must
 * not assume it is available. When storage is blocked there is nothing to remove,
 * so we simply swallow the error.
 */
export const safeRemoveStoredItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    // Storage is unavailable (blocked by the browser) - nothing to remove.
  }
};
